import { toast } from "react-toastify";

import {
  patchObservationStatusEhrPoster,
  type ObservationPatchStatus,
} from "./PatchObservation";

const PATCH_CONCURRENCY = 10;

export type WearableObservationPatchStatus = ObservationPatchStatus;

export interface PatchWearableObservationsStatusIndividualParams {
  observationIds: string[];
  status?: WearableObservationPatchStatus;
}

export interface PatchWearableObservationsStatusIndividualResult {
  patchedCount: number;
  failedCount: number;
}

/**
 * Cancela Observations com **PATCH individual** no EHRPoster (uma requisição por id).
 */
export async function PatchWearableObservationsStatusIndividual({
  observationIds,
  status = "cancelled",
}: PatchWearableObservationsStatusIndividualParams): Promise<PatchWearableObservationsStatusIndividualResult> {
  const uniqueIds = Array.from(
    new Set(observationIds.map((id) => id.trim()).filter(Boolean)),
  );

  if (!uniqueIds.length) {
    return { patchedCount: 0, failedCount: 0 };
  }

  let patchedCount = 0;
  let failedCount = 0;

  for (let index = 0; index < uniqueIds.length; index += PATCH_CONCURRENCY) {
    const chunk = uniqueIds.slice(index, index + PATCH_CONCURRENCY);
    const results = await Promise.allSettled(
      chunk.map((observationId) =>
        patchObservationStatusEhrPoster({ observationId, status }),
      ),
    );

    for (const result of results) {
      if (result.status === "fulfilled") {
        patchedCount += 1;
      } else {
        failedCount += 1;
        console.error(
          "PatchWearableObservationsStatusIndividual failed",
          result.reason,
        );
      }
    }
  }

  if (patchedCount === 0) {
    toast.error("Não foi possível remover os dados. Tente novamente.");
    throw new Error(
      "PatchWearableObservationsStatusIndividual: nenhuma observation atualizada",
    );
  }

  if (failedCount > 0) {
    toast.warning(
      `${patchedCount} registro(s) removido(s). ${failedCount} falha(s) — atualize a página.`,
    );
  } else {
    toast.success("Dados removidos com sucesso.");
  }

  return { patchedCount, failedCount };
}
